// src/workspaces/workspacesApi.ts
import { apiClient } from "@maat/api-base";
var workspacesApi = {
  getMyWorkspaces: async () => {
    return apiClient.get("/main/api/workspaces/my-workspaces");
  },
  /** Admin: searchable (id, name) workspace options for filter pickers. */
  adminSearchWorkspaceOptions: async (params) => {
    return apiClient.get("/main/api/admin/workspaces/options", { params });
  },
  /** Admin: resolve (id, name) for a fixed set of workspace ids — labels admin lists holding only workspace_id. */
  adminResolveWorkspaceNames: async (ids) => {
    return apiClient.get("/main/api/admin/workspaces/options", {
      params: { ids },
      paramsSerializer: { indexes: null }
    });
  },
  createWorkspace: async (data) => {
    return apiClient.post("/main/api/workspaces", data);
  },
  updateProfile: async (data) => {
    return apiClient.patch("/main/api/workspaces/profile", data);
  },
  uploadLogo: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.post("/main/api/workspaces/logo", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  invite: async (workspaceId, data) => {
    return apiClient.post(`/main/api/workspaces/invite/${workspaceId}`, data);
  },
  acceptInvite: async (data) => {
    return apiClient.post("/main/api/workspaces/accept-invitation", data);
  },
  validateInvite: async (token) => {
    return apiClient.get(
      `/main/api/workspaces/validate-invite?token=${encodeURIComponent(token)}`
    );
  },
  getMembers: async (params) => {
    const query = params?.search ? `?search=${encodeURIComponent(params.search)}` : "";
    return apiClient.get(`/main/api/workspaces/members${query}`);
  },
  getInvitations: async () => {
    return apiClient.get("/main/api/workspaces/invitations");
  },
  removeMember: async (workspaceId, userId) => {
    return apiClient.delete(`/main/api/workspaces/${workspaceId}/members/${userId}`);
  },
  /** The workspace's housekeeping rules (`workspace.settings`). */
  getOperationsSettings: async () => {
    return apiClient.get("/main/api/workspaces/operations");
  },
  updateOperationsSettings: async (payload) => {
    return apiClient.patch("/main/api/workspaces/operations", payload);
  },
  /** The active workspace's response time and rate to guest chats (`chat.read`). */
  getResponseStats: async () => {
    return apiClient.get("/main/api/workspaces/response-stats");
  }
};

export {
  workspacesApi
};
